import FormValidator from "@web/vpt-assets/assets/js/utilities/validations/formValidator";

export default class BookingPinsEmailSenderService {
    constructor() {
        this.form = document.querySelector('form#pin-request-form');
        if (!this.form) return;
        this.responseContainer = this.form.querySelector('[data-container="response"]');

        new FormValidator(this.form);
        this.eventDelegation();
        this.initializeFormModal();
    }

    getSubmitButton() {
        return this.form.querySelector('[type="submit"]');
    }

    getEmailInput() {
        return this.form.querySelector('[name="email"]');
    }

    getModal() {
        return document.querySelector('#pin-request-modal');
    }

    initializeFormModal() {
        const requestPinsModal = this.getModal();
        if (!requestPinsModal) return;
        requestPinsModal.addEventListener('custom-modal-show', () => {
            this.toggleForm(true);
        });
    }

    toggleForm(enable) {
        const disabled = enable !== undefined ? !enable : !this.getEmailInput().disabled;
        this.getEmailInput().disabled = disabled;
        const submitButton = this.getSubmitButton();
        submitButton.disabled = disabled;
        submitButton.classList[disabled ? 'add' : 'remove']('disabled');
        if (!disabled) {
            this.responseContainer.innerHTML = '';
            this.responseContainer.hidden = true;
        }
    }
    paintResponse(status, message) {
        const alert = document.createElement('div');
        alert.classList.add(`vpt-alert-${status}-o-full`);
        alert.innerHTML = message;
        this.responseContainer.appendChild(alert);
    }

    eventDelegation() {
        this.form.addEventListener('submitedFormValidated', async (event) => {
            if (!event.detail.isValid) return;
            this.toggleForm(false);
            const response = await fetch(myApp.config.routing.bookings_pins_email_request, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: this.getEmailInput().value
                })
            }).then(r => r.json());
            if (response.status !== 200) {
                this.toggleForm(true);
            }
            this.paintResponse(
                response.status === 200 ? 'success' : 'danger',
                response.message
            );
            this.responseContainer.hidden = false;
        });
    }
}
